import { Component, OnInit, TemplateRef, NgZone } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { AppService } from "../services/app.service";
import * as AWS from "aws-sdk/global";
import * as S3 from "aws-sdk/clients/s3";
import { environment } from "../../environments/environment";
import {
  setMobilePhoneMask as setMobilePhoneMaskUtil,
  chkLength as chkLengthUtil,
} from "../utils/format-util";
import { ToastrService } from "ngx-toastr";
import { Router } from "@angular/router";
import { TypeaheadMatch } from "ngx-bootstrap/typeahead/typeahead-match.class";
import { BsModalService, BsModalRef } from "ngx-bootstrap/modal";
import { SupportService } from "../services/support-service";
import { PatientFormService } from "../services/patient-form.service";
import { FormBuilder, FormGroup, Validators, FormArray } from "@angular/forms";
import { IMyDpOptions } from "mydatepicker";
import { mobiscroll, MbscDatetimeOptions } from '@mobiscroll/angular';
import { DatePipe } from "@angular/common";
import { NgxUiLoaderService } from "ngx-ui-loader";

mobiscroll.settings = {
  theme: 'ios',
  themeVariant: 'light'
};

@Component({
  selector: "app-check-in-patient",
  templateUrl: "./check-in-patient.component.html",
  styleUrls: ["./check-in-patient.component.scss"],
})
export class CheckInPatientComponent implements OnInit {
  modalRef: BsModalRef;
  insuranceList: FormGroup;
  public myDatePickerOptions: IMyDpOptions = {};
  patientForm: FormGroup;
  physicianForm: FormGroup;
  cancelModal: FormGroup;
  scheduleID = "";
  scheduleDetails: any = {};
  scheduleDetail: any = {};
  selectProcedureList: any = [];
  selectedFiles: FileList;
  imgExtension = [];
  fileName: string;
  fileExtenstion: any;
  imageawskey: any;
  request: any;
  url: any;
  imgUrl: any;
  prescriptionUrl = "";
  profileUrl = "";
  patientList: any = [];
  selectedName = "";
  prescriptionImageDetail: any = {};
  licenseDetail: any = {};
  insurancecardUrl = "";
  insurancecarddetail: any = {};
  config = {
    ignoreBackdropClick: true,
  };

  submitted = false;
  medicalQnsList: any = [];
  testCountryCode = "";
  today = new Date();
  successMessage = "";
  errorMessage = "";
  loginUserName = localStorage.getItem("loginUserName");
  selected1: any;
  selected2: any;
  selected = false;
  selectedType: any;
  answered = false;
  checkinbutton = false;
  dataInsurancList = [];
  countryList: any = [];
  formatter: any;
  code = "";
  stateList: any = [];
  futureCheckinDate = true;
  totalAmount = 0;
  medicalqnsList = [];
  items: FormArray;
  insuranceId = "";
  licenseId = "";
  prescriptionId = "";
  noshowreason: any = null;
  cancelsubmit = false;
  dateSettings: MbscDatetimeOptions = {
    dateFormat: 'M dd, yyyy',
    display: 'center'
};
  constructor(
    private route: ActivatedRoute,
    private ngxService: NgxUiLoaderService,
    private router: Router,
    private toastr: ToastrService,
    private modalService: BsModalService,
    private ngZone: NgZone,
    private appservice: AppService,
    private support: SupportService,
    private formBuilder: FormBuilder,
    private datepipe: DatePipe,
    private patientFormService: PatientFormService,
  ) {
    this.loadPatientForm();
    this.loadInsuranceListForm();
    this.loadPhysicianForm();
    this.loadCancelForm();

    this.myDatePickerOptions = {
      dateFormat: "mmm dd, yyyy",
      showClearDateBtn: false,
      editableDateField: true,
      firstDayOfWeek: "su",
      indicateInvalidDate: true,
    };
  }

  loadCancelForm() {
    this.cancelModal = this.formBuilder.group({
      cancelReason: ["", Validators.required],
      cancelCode: ["", Validators.required],
    });
  }

  scrollTop(value) {
    return this.patientFormService.scrollTop(this, value);
  }

  getMedicalQuestionHeader() {
    return this.patientFormService.getMedicalQuestionHeader(this);
  }

  loadPhysicianForm() {
    this.physicianForm = this.formBuilder.group({
      physicianFirstName: ["", Validators.required],
      physicianLastName: ["", Validators.required],
      physicianContactFirstName: [""],
      physicianContactLastName: [""],
      physicianPhoneCode: [""],
      physicianPhoneMask: [""],
      physicianPhone: ["", [Validators.required, Validators.minLength(10)]],
      physicianFaxCode: [""],
      physicianFax: [""],
      physicianFaxMask: [""],
      assistantFirstName: [""],
      assistantLastName: [""],
      assistantPhone: [""],
      assistantPhoneCode: [""],
      assistantPhoneMask: [""],
    });
  }

  onSubmit(patientForm) {
    console.log(patientForm.value.patientDob);
    
    if (!patientForm.value.patientDob) {
      this.scrollTop("patientdobdiv");
      this.checkinbutton = false;
      return;
    } else {
      document.getElementById("physician-form").click();
    }
  }

  onSubmit2(physicianForm) {
    if (physicianForm.valid && this.scheduleDetail.payMode === "insurance") {
      if (this.testCountryCode === "US") {
        document.getElementById("insurance-form").click();
      } else {
        this.checkMedicalQuestion();
      }
    } else if (physicianForm.valid && this.scheduleDetail.payMode === "self") {
      this.checkMedicalQuestion();
    } else {
      this.checkinbutton = false;
    }
  }

  checkQuestion(question, i) {
    return this.patientFormService.checkQuestion(question, i, this.medicalqnsList);
  }

  checkMedicalQuestion() {
    const data = {
      scheduleAppointmentId: this.scheduleID,
      tcProMedQuesOut: this.medicalqnsList,
    };
    this.appservice
      .addorupdateschedmedicalquestions(data)
      .subscribe(() => ({}));
    this.updateScheduleAppoinment();
  }

  onSubmit1(insuranceForm) {
    if (insuranceForm.valid) {
      this.checkMedicalQuestion();
    } else {
      this.checkinbutton = false;
      this.scrollTop("insurancediv");
    }
  }

  chkLength(data) {
    return chkLengthUtil(data);
  }

  updateScheduleAppoinment() {
    const updateSchedule: any = {};
    updateSchedule.id = this.scheduleDetail.id;
    updateSchedule.active = this.scheduleDetail.active;
    updateSchedule.createdOn = this.scheduleDetail.createdOn;
    updateSchedule.scheduledOnStr = this.scheduleDetail.scheduledOnStr;
    updateSchedule.scheduledOn = this.scheduleDetail.scheduledOnStr;
    updateSchedule.scheduleFromTime = this.scheduleDetail.scheduleFromTime;
    updateSchedule.scheduleToTime = this.scheduleDetail.scheduleToTime;
    updateSchedule.deleted = this.scheduleDetail.deleted;
    updateSchedule.patientAddressId = this.scheduleDetail.patientAddressId
      ? this.scheduleDetail.patientAddressId
      : "";
    updateSchedule.patientAddressLine1 = this.patientForm.controls[
      "patientAddress1"
    ].value;
    updateSchedule.patientAddressLine2 = this.patientForm.controls[
      "patientAddress2"
    ].value;
    updateSchedule.patientAreaName = this.scheduleDetail.patientAreaName;
    updateSchedule.patientCityName = this.patientForm.controls[
      "patientCity"
    ].value;
    updateSchedule.patientCountry = this.patientForm.controls[
      "patientCountry"
    ].value;
    updateSchedule.patientDob =  (this.patientForm.get("patientDob").value && this.patientForm.get("patientDob").value != null)?this.datepipe.transform(this.patientForm.get("patientDob").value,"yyyy-MM-dd"):'',
    updateSchedule.patientEmail = this.patientForm.controls["emailId"].value;
    updateSchedule.patientFirstName = this.patientForm.controls[
      "firstName"
    ].value;
    updateSchedule.patientGender = this.patientForm.controls["gender"].value;
    updateSchedule.patientId = this.scheduleDetail.patientId
      ? this.scheduleDetail.patientId
      : "";
    updateSchedule.patientLastName = this.patientForm.controls[
      "lastName"
    ].value;
    updateSchedule.patientPhone = this.patientForm.controls["mobile"].value;
    updateSchedule.patientPhoneCode = this.patientForm.controls[
      "countrydialcode"
    ].value;
    updateSchedule.patientPhoneExtn = "";
    updateSchedule.altPatientPhoneExtn = "";
    updateSchedule.altPatientPhone = this.patientForm.controls[
      "alternatemobile"
    ].value;
    updateSchedule.altPatientPhoneCode = this.patientForm.controls[
      "alternateCountrydialcode"
    ].value;
    updateSchedule.patientState = this.patientForm.controls[
      "patientState"
    ].value;
    updateSchedule.patientZipCode = this.patientForm.controls[
      "patientZipCode"
    ].value;
    if (this.scheduleDetail && this.scheduleDetail.payMode === "insurance") {
      updateSchedule.schedInsuranceId = this.scheduleDetail.schedInsuranceId;
    }
    this.dataInsurancList = [];
    if (
      this.items &&
      this.items.length > 0 &&
      this.scheduleDetail.payMode === "insurance"
    ) {
      for (let index = 0; index < this.items.controls.length; index++) {
        const data = {
          id: this.items.controls[index]["controls"]["id"].value,
          insuranceCustomerCode: this.items.controls[index]["controls"][
            "insuranceCustomerCode"
          ].value,
          insuranceCustomerService: this.items.controls[index]["controls"][
            "insuranceCustomerService"
          ].value,
          insuranceGroupNumber: this.items.controls[index]["controls"][
            "insuranceGroupNumber"
          ].value,
          insuranceIdNumber: this.items.controls[index]["controls"][
            "insuranceIdNumber"
          ].value,
          insuranceType: {
            id: this.items.controls[index]["controls"]["insuranceType"].value,
          },
          insurance: {
            id: this.items.controls[index]["controls"]["insuranceId"].value,
          },
          insuranceTypeName:
            this.items.controls[index]["controls"]["insuranceType"].value === 2
              ? "HMO"
              : "PPO",
        };
        this.dataInsurancList.push(data);
      }
      this.appservice
        .updateschedinsurance(this.dataInsurancList)
        .subscribe(() => ({}));
    }

    updateSchedule.physicianAddressId = this.scheduleDetail.physicianAddressId
      ? this.scheduleDetail.physicianAddressId
      : "";
    updateSchedule.physicianAddressLine1 = this.scheduleDetail.physicianAddressLine1;
    updateSchedule.physicianAddressLine2 = this.scheduleDetail.physicianAddressLine2;
    updateSchedule.physicianAreaName = this.scheduleDetail.physicianAreaName;
    updateSchedule.physicianCityName = this.scheduleDetail.physicianCityName;
    updateSchedule.physicianCountry = this.scheduleDetail.physicianCountry;
    updateSchedule.physicianEmail = this.scheduleDetail.physicianEmail;
    updateSchedule.physicianFax = this.physicianForm.controls[
      "physicianFax"
    ].value;
    updateSchedule.physicianFaxCode = this.physicianForm.controls[
      "physicianFaxCode"
    ].value;
    updateSchedule.physicianExtn = "";
    updateSchedule.physicianFirstName = this.physicianForm.controls[
      "physicianFirstName"
    ].value;
    updateSchedule.physicianGender = this.scheduleDetail.physicianGender;
    updateSchedule.physicianId = this.scheduleDetail.physicianId
      ? this.scheduleDetail.physicianId
      : "";
    updateSchedule.physicianLastName = this.physicianForm.controls[
      "physicianLastName"
    ].value;
    updateSchedule.physicianPhone = this.physicianForm.controls[
      "physicianPhone"
    ].value;
    updateSchedule.physicianPhoneCode = this.physicianForm.controls[
      "physicianPhoneCode"
    ].value;
    updateSchedule.physicianFaxExtn = "";
    updateSchedule.physicianContactFirstName = this.physicianForm.controls[
      "physicianContactFirstName"
    ].value;
    updateSchedule.physicianContactLastName = this.physicianForm.controls[
      "physicianContactLastName"
    ].value;
    updateSchedule.assistantFirstName = this.physicianForm.controls[
      "assistantFirstName"
    ].value;
    updateSchedule.assistantLastName = this.physicianForm.controls[
      "assistantLastName"
    ].value;
    updateSchedule.assistantPhone = this.physicianForm.controls[
      "assistantPhone"
    ].value;
    updateSchedule.assistantPhoneCode = this.physicianForm.controls[
      "assistantPhoneCode"
    ].value;
    updateSchedule.assistantPhoneExtn = "";

    updateSchedule.testCenterId = localStorage
      .getItem("testCenterId")
      .toString();
    updateSchedule.timezone = this.scheduleDetail.timezone;
    updateSchedule.totalAmount = this.scheduleDetail.totalAmount;
    updateSchedule.hearedAboutUs = this.scheduleDetail.hearedAboutUs;
    updateSchedule.others = this.scheduleDetail.others;
    updateSchedule.answered = this.scheduleDetail.answered;
    updateSchedule.notification = this.scheduleDetail.notification;

    this.appservice.updatescheduleappointment(updateSchedule).subscribe(
      (data: any) => {
        if (data.status.status === 200) {
          this.checkIn();
        }
      },
      (err) => {
        this.checkinbutton = false;
      }
    );
  }

  loadInsuranceListForm() {
    this.insuranceList = this.formBuilder.group({
      items: this.formBuilder.array([]),
    });
  }

  callsubmit() {
    this.checkinbutton = true;
    this.submitted = true;
    document.getElementById("patient-form").click();
  }

  loadPatientForm() {
    this.patientForm = this.formBuilder.group({
      firstName: ["", Validators.required],
      lastName: ["", Validators.required],
      emailId: [
        "",
        [
          Validators.required,
          Validators.pattern(/^[A-Za-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/),
        ],
      ],
      countrydialcode: [""],
      mobile: ["", [Validators.required, Validators.minLength(10)]],
      phonemask: [""],
      patientDob: [null, Validators.required],
      gender: ["", Validators.required],
      alternateCountrydialcode: [""],
      alternatemobile: ["", [Validators.minLength(10)]],
      alterphonemask: [""],
      patientState: ["", Validators.required],
      patientCountry: ["", Validators.required],
      patientCity: ["", Validators.required],
      patientAddress1: ["", Validators.required],
      patientAddress2: [""],
      patientZipCode: ["", Validators.required],
      patientzipmask: [""],
    });
  }

  changeMask(type, value) {
    if (type === "phonemask") {
      this.patientForm.controls.phonemask.setValue(
        this.setMobilePhoneMask(value)
      );
    } else if (type === "physicianmask") {
      this.physicianForm.controls.physicianPhoneMask.setValue(
        this.setMobilePhoneMask(value)
      );
    } else if (type === "alternativemask") {
      this.patientForm.controls.alterphonemask.setValue(
        this.setMobilePhoneMask(value)
      );
    } else if (type === "faxmask") {
      this.physicianForm.controls.physicianFaxMask.setValue(
        this.setMobilePhoneMask(value)
      );
    } else if (type === "hmomask") {
      this.physicianForm.controls.assistantPhoneMask.setValue(
        this.setMobilePhoneMask(value)
      );
    }
  }

  ngOnInit() {
    this.support.sidemenuname.next(
      `/${localStorage.getItem("testCode").toString()}/check-in-patient`
    );
    this.getcountry();
    this.viewTestCenter();
    const routeParams = this.route.snapshot.params;
    if (routeParams.patientID) {
      this.scheduleID = routeParams.patientID;
      if (this.scheduleID) {
        setTimeout(() => {
          this.getScheduledetails();
        }, 300);
      }
    } else {
      this.patientForm.controls.alternateCountrydialcode.setValue(
        this.testCountryCode === "IN" ? "+91" : "+1"
      );
      this.patientForm.controls.countrydialcode.setValue(
        this.testCountryCode === "IN" ? "+91" : "+1"
      );
      this.physicianForm.controls.physicianPhoneCode.setValue(
        this.testCountryCode === "IN" ? "+91" : "+1"
      );
      this.physicianForm.controls.physicianFaxCode.setValue(
        this.testCountryCode === "IN" ? "+91" : "+1"
      );
      this.physicianForm.controls.assistantPhoneCode.setValue(
        this.testCountryCode === "IN" ? "+91" : "+1"
      );
    }
    this.getPatientList();
  }

  getcountry() {
    return this.patientFormService.getcountry(this);
  }

  getRound(value): number {
    if (value) {
      return Math.round(value * 100) / 100;
    }
    return 0;
  }

  getFloor(value): number {
    if (value) {
      return Math.floor(value);
    }
    return 0;
  }

  viewTestCenter() {
    this.appservice.viewtestcenter().subscribe(
      (res) => {
        if (
          res &&
          res["status"] &&
          res["status"] &&
          res["status"]["status"] === 200
        ) {
          if (res["entity"]) {
            this.testCountryCode =
              res["entity"]["address"]["country"]["countryCode"];
            if (this.testCountryCode === "US") {
              this.formatter = new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: "USD",
                minimumFractionDigits: 0,
              });
            } else if (this.testCountryCode === "IN") {
              this.formatter = new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: "INR",
                minimumFractionDigits: 0,
              });
            }
          }
        }
      },
      (err) => {
        this.appservice.sessionOut(err);
      }
    );
  }

  getPatientList() {
    return this.patientFormService.getPatientList(this);
  }

  onSelect(event: TypeaheadMatch): void {
    this.scheduleDetail = {};
    this.selectProcedureList = [];
    this.appservice.getPatientScheduleList(event.item.id).subscribe(
      (schedule) => {
        if (schedule["status"]["status"] === 200) {
          if (schedule["entity"].length > 0) {
            this.scheduleID = schedule["entity"][0].id;
            this.getScheduledetails();
          } else {
            this.toastr.error("Schedule list is empry");
          }
        } else {
          this.toastr.error("Schedule list is empry");
        }
      },
      (err) => {
        this.toastr.error("Schedule list is empry");
      }
    );
  }
  checkCode() {
    this.successMessage = "";
    this.errorMessage = "";
    if (this.code) {
      const json = {
        id: this.scheduleDetail.id,
        bookingCode: this.code,
      };
      this.appservice.checkPatientCode(json).subscribe((res) => {
        if (res && res["status"] && res["status"]["status"] === 200) {
          this.callsubmit();
        } else if (res && res["status"] && res["status"]["status"] === 243) {
          this.errorMessage = "Patient code mismatch";
        } else if (res && res["status"] && res["status"]["status"] === 204) {
          this.errorMessage = "Not found";
        }
      });
    } else {
      this.callsubmit();
    }
  }

  convertTime12to24 = (time12h) => {
    const [time, modifier] = time12h.split(" ");
    let [hours, minutes] = time.split(":");
    if (hours === "12") {
      hours = "00";
    }
    if (modifier === "PM") {
      hours = parseInt(hours, 10) + 12;
    }
    return `${hours}:${minutes}`;
  };

  setMobilePhoneMask(phoneCode) {
    return setMobilePhoneMaskUtil(phoneCode, this.testCountryCode);
  }

  setDateToDatePicker(dateStr) {
    return this.patientFormService.setDateToDatePicker(dateStr);
  }

  changeCountry(countryid) {
    if (countryid && (countryid === 101 || countryid === "101")) {
      this.patientForm.controls["patientzipmask"].setValue("000000");
    } else if (countryid && (countryid === 231 || countryid === "231")) {
      this.patientForm.controls["patientzipmask"].setValue("00000");
    }
    if (countryid) {
      this.getStateList(countryid);
    }
  }
  getStateList(countryid) {
    return this.patientFormService.getStateList(this, countryid);
  }

  setZipcodeMask(countryCode) {
    let mask = "";
    if (countryCode) {
      if (countryCode === 101 || countryCode === "101") {
        mask = "000000";
      } else if (countryCode === 231 || countryCode === "231") {
        mask = "00000";
      }
    }
    return mask;
  }
  getScheduledetails() {
    this.futureCheckinDate = true;
    let gender = null;
    this.appservice
      .viewscheduleappointmentpro(this.scheduleID)
      .subscribe((scheduleDetail: any) => {
        if (scheduleDetail.status.status === 200) {
          this.scheduleDetails = scheduleDetail.entity;
          this.scheduleDetail = this.scheduleDetails.schedule;
          if (
            this.scheduleDetails &&
            this.scheduleDetails.schedPrescription &&
            this.scheduleDetails.schedPrescription.length > 0
          ) {
            for (
              let index = 0;
              index < this.scheduleDetails.schedPrescription.length;
              index++
            ) {
              if (
                this.scheduleDetails.schedPrescription[index].documentType ===
                "insurancecard"
              ) {
                this.insuranceId = this.scheduleDetails.schedPrescription[
                  index
                ].id;
                this.insurancecardUrl = this.scheduleDetails.schedPrescription[
                  index
                ].prescriptionImageKey;
                this.insurancecarddetail.fileName = this.scheduleDetails.schedPrescription[
                  index
                ].prescriptionImageKey;
                this.insurancecarddetail.type = "insurancecard";
              } else if (
                this.scheduleDetails.schedPrescription[index].documentType ===
                "licence"
              ) {
                this.licenseId = this.scheduleDetails.schedPrescription[
                  index
                ].id;
                this.profileUrl = this.scheduleDetails.schedPrescription[
                  index
                ].prescriptionImageKey;
                this.licenseDetail.fileName = this.scheduleDetails.schedPrescription[
                  index
                ].prescriptionImageKey;
                this.licenseDetail.type = "licence";
              } else if (
                this.scheduleDetails.schedPrescription[index].documentType ===
                "prescription"
              ) {
                this.prescriptionId = this.scheduleDetails.schedPrescription[
                  index
                ].id;
                this.prescriptionUrl = this.scheduleDetails.schedPrescription[
                  index
                ].prescriptionImageKey;
                this.prescriptionImageDetail.fileName = this.scheduleDetails.schedPrescription[
                  index
                ].prescriptionImageKey;
                this.prescriptionImageDetail.type = "prescription";
              }
            }
          }

          if (this.scheduleDetail) {
            this.patientForm.controls.firstName.setValue(
              this.scheduleDetail.patientFirstName
            );
            this.patientForm.controls.lastName.setValue(
              this.scheduleDetail.patientLastName
            );
            this.patientForm.controls.emailId.setValue(
              this.scheduleDetail.patientEmail
            );
            this.patientForm.controls.countrydialcode.setValue(
              this.scheduleDetail.patientPhoneCode
                ? this.scheduleDetail.patientPhoneCode
                : this.testCountryCode === "US"
                ? "+1"
                : "+91"
            );
            this.patientForm.controls.phonemask.setValue(
              this.setMobilePhoneMask(this.scheduleDetail.patientPhoneCode)
            );
            this.patientForm.controls.mobile.setValue(
              this.scheduleDetail.patientPhone
            );
            this.patientForm.controls.gender.setValue(
              this.scheduleDetail.patientGender
            );
            
            if(this.scheduleDetail.patientDob){
              var splitDate = this.scheduleDetail.patientDob.toString().split("-");
              var patientdob = new Date();
              patientdob.setFullYear(+splitDate[0]);
              patientdob.setMonth(+splitDate[1] - 1);
              patientdob.setDate(+splitDate[2]);
              patientdob.setHours(0);
              patientdob.setMinutes(0);
              this.patientForm.controls.patientDob.setValue(patientdob);
            }

            if (this.scheduleDetail.altPatientPhone) {
              this.patientForm
                .get("alternatemobile")
                .setValidators(
                  Validators.compose([
                    Validators.required,
                    Validators.minLength(10),
                  ])
                );
              this.patientForm.get("alternatemobile").updateValueAndValidity();

              this.patientForm.controls.alternateCountrydialcode.setValue(
                this.scheduleDetail.patientPhoneCode
                  ? this.scheduleDetail.patientPhoneCode
                  : this.testCountryCode === "US"
                  ? "+1"
                  : "+91"
              );
              this.patientForm.controls.alternatemobile.setValue(
                this.scheduleDetail.altPatientPhone
              );
              this.patientForm.controls.alterphonemask.setValue(
                this.setMobilePhoneMask(this.scheduleDetail.patientPhoneCode)
              );
            }

            this.patientForm.controls.patientAddress1.setValue(
              this.scheduleDetail.patientAddressLine1
            );
            this.patientForm.controls.patientAddress2.setValue(
              this.scheduleDetail.patientAddressLine2
            );
            this.patientForm.controls.patientCity.setValue(
              this.scheduleDetail.patientCityName
            );
            this.patientForm.controls.patientCountry.setValue(
              this.scheduleDetail.patientCountry
                ? this.scheduleDetail.patientCountry
                : this.testCountryCode === "US"
                ? 231
                : 101
            );
            this.getStateList(this.patientForm.controls.patientCountry.value);
            this.patientForm.controls.patientZipCode.setValue(
              this.scheduleDetail.patientZipCode
            );
            this.patientForm.controls.patientzipmask.setValue(
              this.setZipcodeMask(
                this.patientForm.controls.patientCountry.value
              )
            );
            this.patientForm.controls.patientState.setValue(
              this.scheduleDetail.patientState
                ? this.scheduleDetail.patientState
                : ""
            );

            if (
              this.testCountryCode === "US" &&
              this.scheduleDetail.payMode === "insurance" &&
              this.scheduleDetails.schedInsurance &&
              this.scheduleDetails.schedInsurance.length > 0
            ) {
              this.items = this.insuranceList.get("items") as FormArray;
              for (
                let index = 0;
                index < this.scheduleDetails.schedInsurance.length;
                index++
              ) {
                this.items.push(
                  this.formBuilder.group({
                    id: [this.scheduleDetails.schedInsurance[index].id],
                    insuranceName: [
                      this.scheduleDetails.schedInsurance[index].insuranceName,
                      Validators.required,
                    ],
                    insuranceType: [
                      this.scheduleDetails.schedInsurance[index]
                        .insuranceTypeId,
                      Validators.required,
                    ],
                    insuranceTypeName: [
                      this.scheduleDetails.schedInsurance[index]
                        .insuranceTypeId === 2
                        ? "HMO"
                        : "PPO",
                    ],
                    insuranceId: [
                      this.scheduleDetails.schedInsurance[index].insuranceId,
                      Validators.required,
                    ],
                    insuranceIdNumber: [
                      this.scheduleDetails.schedInsurance[index]
                        .insuranceIdNumber,
                      Validators.required,
                    ],
                    insuranceGroupNumber: [
                      this.scheduleDetails.schedInsurance[index]
                        .insuranceGroupNumber,
                      Validators.required,
                    ],
                    insuranceCustomerService: [
                      this.scheduleDetails.schedInsurance[index]
                        .insuranceCustomerService,
                    ],
                    insuranceCustomerCode: [
                      this.scheduleDetails.schedInsurance[index]
                        .insuranceCustomerCode
                        ? this.scheduleDetails.schedInsurance[index]
                            .insuranceCustomerCode
                        : "+1",
                    ],
                    insuranceCusPhoneMask: [
                      this.setMobilePhoneMask(
                        this.scheduleDetails.schedInsurance[index]
                          .insuranceCustomerCode
                      ),
                    ],
                  })
                );
              }
            } else if (
              this.testCountryCode === "IN" &&
              this.scheduleDetail.payMode === "insurance"
            ) {
              this.items = this.insuranceList.get("items") as FormArray;
              for (
                let index = 0;
                index < this.scheduleDetails.schedInsurance.length;
                index++
              ) {
                this.items.push(
                  this.formBuilder.group({
                    id: [this.scheduleDetails.schedInsurance[index].id],
                    insuranceName: [
                      this.scheduleDetails.schedInsurance[index].insuranceName,
                    ],
                    insuranceType: [
                      this.scheduleDetails.schedInsurance[index]
                        .insuranceTypeId,
                    ],
                    insuranceTypeName: [
                      this.scheduleDetails.schedInsurance[index]
                        .insuranceTypeId === 2
                        ? "HMO"
                        : "PPO",
                    ],
                    insuranceId: [
                      this.scheduleDetails.schedInsurance[index].insuranceId,
                    ],
                    insuranceIdNumber: [
                      this.scheduleDetails.schedInsurance[index]
                        .insuranceIdNumber,
                    ],
                    insuranceGroupNumber: [
                      this.scheduleDetails.schedInsurance[index]
                        .insuranceGroupNumber,
                    ],
                    insuranceCustomerService: [
                      this.scheduleDetails.schedInsurance[index]
                        .insuranceCustomerService,
                    ],
                    insuranceCustomerCode: [
                      this.scheduleDetails.schedInsurance[index]
                        .insuranceCustomerCode
                        ? this.scheduleDetails.schedInsurance[index]
                            .insuranceCustomerCode
                        : "+1",
                    ],
                    insuranceCusPhoneMask: [
                      this.setMobilePhoneMask(
                        this.scheduleDetails.schedInsurance[index]
                          .insuranceCustomerCode
                      ),
                    ],
                  })
                );
              }
            }

            this.physicianForm.controls.physicianLastName.setValue(
              this.scheduleDetail.physicianLastName
            );
            this.physicianForm.controls.physicianFirstName.setValue(
              this.scheduleDetail.physicianFirstName
            );
            this.physicianForm.controls.physicianContactFirstName.setValue(
              this.scheduleDetail.physicianContactFirstName
            );
            this.physicianForm.controls.physicianContactLastName.setValue(
              this.scheduleDetail.physicianContactLastName
            );
            this.physicianForm.controls.physicianPhoneCode.setValue(
              this.scheduleDetail.physicianPhoneCode
                ? this.scheduleDetail.physicianPhoneCode
                : this.testCountryCode === "US"
                ? "+1"
                : "+91"
            );
            this.physicianForm.controls.physicianPhoneMask.setValue(
              this.setMobilePhoneMask(
                this.physicianForm.controls.physicianPhoneCode.value
              )
            );
            this.physicianForm.controls.physicianPhone.setValue(
              this.scheduleDetail.physicianPhone
            );
            this.physicianForm.controls.physicianFaxCode.setValue(
              this.scheduleDetail.physicianFaxCode
                ? this.scheduleDetail.physicianFaxCode
                : this.testCountryCode === "US"
                ? "+1"
                : "+91"
            );
            this.physicianForm.controls.physicianFaxMask.setValue(
              this.setMobilePhoneMask(
                this.physicianForm.controls.physicianFaxCode.value
              )
            );
            this.physicianForm.controls.physicianFax.setValue(
              this.scheduleDetail.physicianFax
            );

            if (
              this.scheduleDetail &&
              this.scheduleDetail.payMode === "insurance" &&
              this.scheduleDetail.insuranceType === 2 &&
              this.testCountryCode === "US"
            ) {
              this.physicianForm
                .get("assistantLastName")
                .setValidators(Validators.compose([Validators.required]));
              this.physicianForm
                .get("assistantFirstName")
                .setValidators(Validators.compose([Validators.required]));
              this.physicianForm
                .get("assistantPhone")
                .setValidators(
                  Validators.compose([
                    Validators.required,
                    Validators.minLength(10),
                  ])
                );
              this.physicianForm
                .get("assistantLastName")
                .updateValueAndValidity();
              this.physicianForm
                .get("assistantFirstName")
                .updateValueAndValidity();
              this.physicianForm.get("assistantPhone").updateValueAndValidity();

              this.physicianForm.controls.assistantFirstName.setValue(
                this.scheduleDetail.assistantFirstName
              );
              this.physicianForm.controls.assistantLastName.setValue(
                this.scheduleDetail.assistantLastName
              );
              this.physicianForm.controls.assistantPhoneCode.setValue(
                this.scheduleDetail.assistantPhoneCode
                  ? this.scheduleDetail.assistantPhoneCode
                  : this.testCountryCode === "US"
                  ? "+1"
                  : "+91"
              );
              this.physicianForm.controls.assistantPhoneMask.setValue(
                this.setMobilePhoneMask(
                  this.physicianForm.controls.assistantPhoneCode.value
                )
              );
              this.physicianForm.controls.assistantPhone.setValue(
                this.scheduleDetail.assistantPhone
              );
            }
          }

          gender = this.scheduleDetail.patientGender;

          if (
            gender &&
            ((this.scheduleDetail.preAuthorized === true &&
              this.scheduleDetail.payMode === "insurance") ||
              this.scheduleDetail.payMode === "self")
          ) {
            this.medicalQnsList = [];
            this.appservice.getmedicalqns(this.scheduleID).subscribe((res) => {
              if (res && res["entity"]) {
                this.medicalqnsList = res["entity"];
                if (this.medicalqnsList && this.medicalqnsList.length > 0) {
                  for (
                    let index = 0;
                    index < this.medicalqnsList.length;
                    index++
                  ) {
                    this.medicalqnsList[index].schedMedicalQuestions.forEach(
                      (medical) => {
                        if (gender.toLowerCase() === "female") {
                          medical.isShow = true;
                        } else {
                          medical.isShow = true;
                          if (
                            medical.medicalQuestion.medicalQuestion.gender.toLowerCase() ===
                            "female"
                          ) {
                            medical.isShow = false;
                          }
                        }
                        if (
                          medical.medicalQuestion.medicalQuestion
                            .yesOrNoText === "false"
                        ) {
                          medical.yesOrNoText = false;
                        } else {
                          medical.yesOrNoText = true;
                        }

                        if (
                          (medical.medicalQuestion.medicalQuestion.question.indexOf(
                            "Height"
                          ) !== -1 ||
                            medical.medicalQuestion.medicalQuestion.question.indexOf(
                              "height"
                            ) !== -1) &&
                          ((medical.medicalQuestion.medicalQuestion.question.indexOf(
                            "Weight"
                          ) &&
                            -1) ||
                            (medical.medicalQuestion.medicalQuestion.question.indexOf(
                              "weight"
                            ) &&
                              -1))
                        ) {
                          medical.isHeightWeight = true;
                        } else {
                          medical.isHeightWeight = false;
                        }
                      }
                    );
                  }
                }
              }
            });
          }

          const last = new Date();
          last.setHours(23);
          last.setMinutes(59);
          last.setSeconds(59);

          if (
            new Date(
              this.scheduleDetail.scheduledOnStr +
                " " +
                this.convertTime12to24(this.scheduleDetail.scheduleFromTime)
            ).getTime() < last.getTime()
          ) {
            this.futureCheckinDate = false;
          }
          if (this.scheduleDetails.procedures) {
            if (this.scheduleDetails.procedures.length > 0) {
              this.selectProcedureList = this.scheduleDetails.schedProEquips;

              this.selectProcedureList.forEach((amount) => {
                this.totalAmount += +amount.amount;
              });
            }
          }
        }
      });
  }

  changed(value, type, index2, medicalqnslist, qnsList) {
    qnsList.answered = true;
    this.answered = true;
    if (type === "yes") {
      medicalqnslist.schedMedicalQuestions[index2].selected1 = true;
      medicalqnslist.schedMedicalQuestions[index2].selected2 = false;
      medicalqnslist.schedMedicalQuestions[index2].answer1 = "";
      medicalqnslist.schedMedicalQuestions[index2].answer1 = "Yes";
    }
    if (type === "no") {
      medicalqnslist.schedMedicalQuestions[index2].selected1 = false;
      medicalqnslist.schedMedicalQuestions[index2].selected2 = true;
      medicalqnslist.schedMedicalQuestions[index2].answer1 = "";
      medicalqnslist.schedMedicalQuestions[index2].answer1 = "No";
    }
  }

  answerChange(input, qnsList) {
    this.answered = true;
    if (input) {
      qnsList.answered = true;
    } else {
      qnsList.answered = false;
    }
  }

  sendMessage(value) {
    if (this.scheduleID) {
      const data = {
        id: this.scheduleID,
        msgType: value,
      };
      this.appservice.sendMessages(data).subscribe((res) => {
        if (res && res["status"] && res["status"]["status"] === 200) {
          this.errorMessage = "";
          this.successMessage =
            (value === "sms" ? "SMS" : "Email") + " sent successfully";
          setTimeout(() => {
            this.successMessage = "";
            this.errorMessage = "";
          }, 5000);
        }
      });
    }
  }

  onFileChange(event, type) {
    if (event.target.files && event.target.files.length) {
      this.ngxService.start();
      const [file] = event.target.files;
      this.awsUploadFile(file, type);
    }
  }
  awsUploadFile(file, type) {
    AWS.config.region = environment.awsRegion;
    AWS.config.credentials = new AWS.CognitoIdentityCredentials({
      IdentityPoolId: environment.awsIdentityPoolId,
    });
    if (file) {
      const that = this;
      const fileDetails = this.getCredential(file);
      if (
        fileDetails.fileExtenstion === ".png" ||
        fileDetails.fileExtenstion === ".jpg" ||
        fileDetails.fileExtenstion === ".jpeg" ||
        fileDetails.fileExtenstion === ".pdf" ||
        fileDetails.fileExtenstion === ".xls" ||
        fileDetails.fileExtenstion === ".doc" ||
        fileDetails.fileExtenstion === ".docx" ||
        fileDetails.fileExtenstion === ".xlsx"
      ) {
        const params = this.getParams(file, fileDetails);
        const Obj = this;
        Obj.imageawskey = fileDetails.fileName;
        const bucket = new S3({
          params: {
            Bucket: params.Bucket,
          },
        });
        params.ContentType = file.type;
        this.request = bucket
          .upload(params)
          .on("httpUploadProgress", function (evt) {})
          .send(function (err, response) {
            if (response) {
              that.toastr.success("Uploaded Successfully");
              that.ngxService.stop()
              if (type === "prescription") {
                that.prescriptionId = "";
                that.prescriptionUrl = response.key;
                that.prescriptionImageDetail.fileName = fileDetails.fileName;
                that.prescriptionImageDetail.type = "prescription";
              } else if (type === "profile") {
                that.licenseId = "";
                that.profileUrl = response.key;
                that.licenseDetail.fileName = fileDetails.fileName;
                that.licenseDetail.type = "licence";
              } else {
                that.insuranceId = "";
                that.insurancecardUrl = response.key;
                that.insurancecarddetail.fileName = fileDetails.fileName;
                that.insurancecarddetail.type = "insurancecard";
              }
            } else {
              that.toastr.error("Image Upload Server Problem!");
              that.ngxService.stop();
            }
          });
      } else {
        this.ngxService.stop();
        this.toastr.error("Invalid Document " + fileDetails.fileExtenstion);
        return;
      }
    }
  }

  getCredential(file): any {
    this.imgExtension = file.name.slice(file.name.lastIndexOf("."));
    this.fileName = file.name;
    this.fileExtenstion = this.imgExtension;
    const credentials = {
      fileExtenstion: this.imgExtension,
      fileName: file.name,
    };
    return credentials;
  }

  private getParams(file, fileDetails): any {
    // Math.random() + Date.now() provides sufficient uniqueness for S3 key generation; access security is enforced by AWS IAM/bucket policies, not key secrecy.
    const params = {
      Bucket: environment.s3Bucket,
      Key:
        environment.s3Folder +
        Math.floor(Math.random() * 100000) +
        Date.now().toString() +
        fileDetails.fileExtenstion,
      Body: file,
    };
    return params;
  }

  checkIn() {
    if (this.scheduleID) {
      const params: any = {};
      params.scheduleId = this.scheduleID;
      params.patientCheckIn = true;
      params.schedPrescription = [
        {
          id: this.prescriptionId,
          prescriptionImageKey: this.prescriptionUrl,
          documentType: this.prescriptionImageDetail.type
            ? this.prescriptionImageDetail.type
            : "",
        },
        {
          id: this.licenseId,
          prescriptionImageKey: this.profileUrl,
          documentType: this.licenseDetail.type ? this.licenseDetail.type : "",
        },
        {
          id: this.insuranceId,
          prescriptionImageKey: this.insurancecardUrl,
          documentType: this.insurancecarddetail.type
            ? this.insurancecarddetail.type
            : "",
        },
      ];

      this.appservice.patientCheckin(params).subscribe((data) => {
        if (data["entity"]["patientCheckIn"] === true) {
          this.submitted = false;
          this.toastr.success("Patient Checked In Successfully");
          this.support.sidemenuname.next(
            `/${localStorage.getItem("testCode").toString()}/home-calendar`
          );
          this.router.navigate([
            `/${localStorage.getItem("testCode").toString()}/home-calendar`,
          ]);
        }
      });
    }
  }

  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(
      template,
      Object.assign({ class: "modal-lg popup-center" })
    );
  }
  gotoNoshow(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(
      template,
      Object.assign(this.config, { class: "popup-center" })
    );
  }

  triggerPopup() {
    if (this.scheduleID) {
      const params: any = {};
      params.id = this.scheduleID;
      params.userId = sessionStorage.getItem("userid");
      params.noshowReason = this.noshowreason;
      this.appservice.noshowschedule(params).subscribe((schedule) => {
        if (schedule["status"]["status"] === 200) {
          this.modalRef.hide();
          this.ngZone.run(() => {
            this.toastr.success("Appointment hidden successfully");
            sessionStorage.setItem("cancelornoshowtab", "noshowtab");
            this.router.navigate([
              `/${localStorage.getItem("testCode").toString()}/home-calendar/`,
            ]);
          });
        }
      });
    }
  }

  gotoCancel(cancelModal) {
    this.cancelsubmit = true;
    if (cancelModal.invalid) {
      return;
    }

    if (this.scheduleID) {
      const params: any = {};
      params.id = this.scheduleID;
      params.cancelReason = this.cancelModal.controls.cancelReason.value;
      params.cancelCode = this.cancelModal.controls.cancelCode.value;
      params.userId = sessionStorage.getItem("userid");
      params.testCenterId = localStorage.getItem("testCenterId");
      this.appservice.cancelscheduleByCode(params).subscribe((schedule) => {
        if (schedule["status"]["status"] === 200) {
          this.modalRef.hide();
          this.ngZone.run(() => {
            this.toastr.success("Appointment cancelled");
            this.router.navigate([
              `/${localStorage.getItem("testCode").toString()}/home-calendar/`,
            ]);
          });
        } else {
          this.toastr.error(schedule["status"]["msg"]);
        }
      });
    }
  }

  gotoReschedule() {
    if (this.scheduleID) {
      this.modalRef.hide();
      sessionStorage.removeItem("waitingid");
      sessionStorage.removeItem("waitinglistpatient");
      this.router.navigate([
        `/${localStorage.getItem("testCode").toString()}/schedule-appointment/${
          this.scheduleID
        }`,
      ]);
    }
  }

  closePrescription() {
    this.prescriptionImageDetail = {};
    this.prescriptionUrl = "";
    this.prescriptionId = "";
  }

  public openPrescription(key): any {
    if (key) {
      // window.location.href = environment.cloudFrontURL + key;
      window.open(environment.cloudFrontURL + key, '_blank');
    }
  }

  closeLicense() {
    this.profileUrl = "";
    this.licenseDetail = {};
    this.insuranceId = "";
  }

  closeInsuranceCard() {
    this.insurancecardUrl = "";
    this.insurancecarddetail = {};
    this.insuranceId = "";
  }
}
